import { cssPropertiesService } from "../core/services/css-properties.service";

// Main PromptBox widget export
export { PromptBox } from "./promptbox.widget";

// Models
export * from "./models";

// Constants
export * from "./constants";

// Templates
export * from "./templates";

// Register PromptBox CSS properties
// PromptBox uses k-input prefix for fillMode (k-input-solid, k-input-outline, k-input-flat)
const cssProps = cssPropertiesService;
cssProps.registerPrefix("PromptBox", "k-input-");
cssProps.registerValues("PromptBox", [{
    prop: "fillMode",
    values: cssProps.fillModeValues
}]);
